import { ToastType } from '@components/toast';
import { PaymentRequestPostRequestBody, PaymentRequestPostResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useCreatePaymentRequest = () => {
  const client = useClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutationFn = async (requestBody: PaymentRequestPostRequestBody) =>
    client
      .post(`payment-request`, {
        json: requestBody,
      })
      .json<PaymentRequestPostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (data) => {
      return data;
    },
    onError: async (e) => {
      console.error(e);
      const message = await getApiErrorMessage(e, 'An unknown error occurred');
      enqueueSnackbar(message, {
        variant: ToastType.Error,
      });
    },
  });
  return { ...result, createPaymentRequest: result.mutateAsync };
};
